/**
 * 品牌 API 服务
 * 用于获取品牌缓存列表
 * 直接访问后端，与原有方式一致（不需要代理）
 */

// 品牌类型
export interface CosBrand {
  id: number;
  name?: string;
  code?: string;
  desc?: string;
  logo?: string;
  sort?: number;
  status?: number;
  createTime?: number;
  updateTime?: number;
}

export interface CosBrandListResponse {
  code: number;
  message?: string;
  msg?: string;
  data?: {
    total: number;
    list: CosBrand[];
  };
}

export interface CosBrandQueryParams {
  pageNum?: number;
  pageSize?: number;
  name?: string;
  code?: string;
  status?: number;
}

/**
 * 获取品牌列表（从缓存）
 * 直接访问后端，与原有方式一致（不需要代理）
 */
export async function getBrandList(params?: CosBrandQueryParams): Promise<CosBrandListResponse> {
  // 使用 apiClient，直接访问后端（与原有方式一致，不需要代理）
  const { apiClient } = await import('../config/netConfig');

  const queryParams = new URLSearchParams();
  if (params?.pageNum !== undefined) queryParams.append('pageNum', String(params.pageNum));
  if (params?.pageSize !== undefined) queryParams.append('pageSize', String(params.pageSize));
  if (params?.name) queryParams.append('name', params.name);
  if (params?.code) queryParams.append('code', params.code);
  if (params?.status !== undefined) queryParams.append('status', String(params.status));

  const queryString = queryParams.toString();
  const basePath = '/brand/list';
  const url = queryString ? `${basePath}?${queryString}` : basePath;

  console.log('📤 请求品牌列表（从 cos_brand_cache 表，直接访问后端）:', url);
  
  const response = await apiClient.get<CosBrandListResponse>(url);

  console.log('📥 品牌列表响应（来自 cos_brand_cache 表）:', response.data);
  
  return response.data;
}
